import { useEffect } from 'react'

import { ClickAwayListener } from '@mui/material'
import { Icon, Typography } from 'components'

import * as S from './style'

type StyleProps = { [key: string]: string }

type ModalContentLayoutProps = {
  closeAction: () => void
  title?: string | React.ReactNode
  titleSize?: number
  description?: string | React.ReactNode
  width?: number | string
  children?: React.ReactNode
  closeButton?: boolean
  styleContent?: StyleProps
}

export const ModalContentLayout = ({
  closeAction,
  title,
  titleSize = 16,
  description,
  width = 400,
  children,
  closeButton,
  styleContent,
}: ModalContentLayoutProps) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closeAction()
      }
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [closeAction])

  return (
    <S.Wrapper>
      <ClickAwayListener mouseEvent="onMouseDown" onClickAway={closeAction}>
        <S.Content style={styleContent} width={width}>
          <S.HeadTexts>
            {title && (
              <S.Head>
                <S.Title titleSize={titleSize}>{title}</S.Title>
                {closeButton && (
                  <S.CloseButton onClick={closeAction}>
                    <Icon icon="close" size="28" />
                  </S.CloseButton>
                )}
              </S.Head>
            )}
            {description && <Typography design="hav-h8-text">{description}</Typography>}
          </S.HeadTexts>
          {children}
        </S.Content>
      </ClickAwayListener>
    </S.Wrapper>
  )
}
